import { Navigate, useLocation } from 'react-router-dom';

/**
 * A fixed redirect that keeps the old URL's query string and hash: a parameter on the old URL (a student, a filter)
 * still arrives, and the target's own parameters (its tab) win over one of the same name.
 */
export function RedirectKeepingQuery({ to }: { to: string }) {
  const { search, hash } = useLocation();
  const [path = '', targetQuery = ''] = to.split('?');
  const params = new URLSearchParams(search);
  for (const [key, value] of new URLSearchParams(targetQuery)) params.set(key, value);
  return <Navigate to={{ pathname: path, search: params.toString(), hash }} replace />;
}
